"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeaserCards = void 0;
var TeaserCards = /** @class */ (function () {
    function TeaserCards(container) {
        this.container = container;
        this.resizeTimer = 0;
        this.scrollContainer = this.getElement('.teaser-cards__scroll-container');
        this.prevButton = this.getElement('.teaser-cards__arrow--prev');
        this.nextButton = this.getElement('.teaser-cards__arrow--next');
        this.init();
    }
    TeaserCards.prototype.getElement = function (selector) {
        var element = this.container.querySelector(selector);
        if (!element)
            throw new Error("Element ".concat(selector, " wurde nicht gefunden."));
        return element;
    };
    TeaserCards.prototype.init = function () {
        this.bindArrowEvents();
        this.bindScrollEvents();
        this.bindResizeEvents();
        this.updateControls();
    };
    TeaserCards.prototype.bindArrowEvents = function () {
        var _this = this;
        this.prevButton.addEventListener('click', function () { return _this.scrollByPage(-1); });
        this.nextButton.addEventListener('click', function () { return _this.scrollByPage(1); });
    };
    TeaserCards.prototype.bindScrollEvents = function () {
        var _this = this;
        this.scrollContainer.addEventListener('scroll', function () { return _this.updateControls(); }, { passive: true });
    };
    TeaserCards.prototype.bindResizeEvents = function () {
        var _this = this;
        window.addEventListener('resize', function () {
            window.clearTimeout(_this.resizeTimer);
            _this.resizeTimer = window.setTimeout(function () {
                _this.updateControls();
            }, 120);
        });
    };
    TeaserCards.prototype.scrollByPage = function (direction) {
        this.scrollContainer.scrollBy({
            left: this.scrollContainer.clientWidth * direction,
            behavior: 'smooth',
        });
    };
    TeaserCards.prototype.updateControls = function () {
        var maxScrollLeft = this.scrollContainer.scrollWidth - this.scrollContainer.clientWidth;
        var hasOverflow = maxScrollLeft > 1;
        var isAtStart = this.scrollContainer.scrollLeft <= 1;
        var isAtEnd = this.scrollContainer.scrollLeft >= maxScrollLeft - 1;
        this.prevButton.hidden = !hasOverflow;
        this.nextButton.hidden = !hasOverflow;
        var prevDisabled = !hasOverflow || isAtStart;
        var nextDisabled = !hasOverflow || isAtEnd;
        if (prevDisabled && document.activeElement === this.prevButton) {
            this.nextButton.focus();
        }
        else if (nextDisabled && document.activeElement === this.nextButton) {
            this.prevButton.focus();
        }
        this.prevButton.disabled = prevDisabled;
        this.nextButton.disabled = nextDisabled;
    };
    return TeaserCards;
}());
exports.TeaserCards = TeaserCards;
